import { createAction } from '@ngrx/store'

export const RESET_LOADING = 'RESET_LOADING'

export const resetLoading = createAction(RESET_LOADING)
